import React, { useState } from "react";
import PurchaseHistoryView from "./PurchaseHistoryView";
import PurchaseReceiveView from "./PurchaseReceiveView";

export default function PurchasesView({ categories = [], onInventoryChanged }) {
  const [tab, setTab] = useState("receive");
  return (
    <section className="purchases-view">
      <nav className="purchases-tabs" aria-label="Purchase workspace">
        <button
          type="button"
          className={tab === "receive" ? "is-active" : ""}
          aria-current={tab === "receive" ? "page" : undefined}
          onClick={() => setTab("receive")}
        >
          Receive goods
          <small>ပစ္စည်းလက်ခံ</small>
        </button>
        <button
          type="button"
          className={tab === "history" ? "is-active" : ""}
          aria-current={tab === "history" ? "page" : undefined}
          onClick={() => setTab("history")}
        >
          Purchase history
          <small>ကုန်ဝယ်စာရင်း</small>
        </button>
      </nav>
      {tab === "receive" ? (
        <PurchaseReceiveView
          categories={categories}
          onInventoryChanged={onInventoryChanged}
          onReceived={() => setTab("history")}
        />
      ) : (
        <PurchaseHistoryView onInventoryChanged={onInventoryChanged} />
      )}
    </section>
  );
}
